import { ApiEndpoint } from 'controller/endpoint'

export const getPerformerKey = ({ id, language }: { id: string; language: string }) =>
  `${ApiEndpoint.performer.details(id)}/${language}`
